/* eslint-disable prettier/prettier */
/* eslint-disable max-len */
import React from 'react';
import { SvgIcon } from 'components/SvgIcon';
import { IThankYou } from 'services/ThankYouService';
import { enPaymentMethod } from 'enums/enPaymentMethod';
import Translate from 'components/Translate';
import { SupportContactText } from '../../Text/SupportContactText';

interface IProps {
  model: IThankYou;
}

const Info: React.FC<IProps> = ({ model }) => {
  const textInformation = {
    [enPaymentMethod.BANKSLIP]: (
      <p>
        <Translate
          hasHTML
          term="Este é um produto digital, assim que o boleto for pago faremos a entrega do seu conteúdo no seu <b>e-mail</b>. Enquanto isso, confirme os seus dados."
        />
      </p>
    )
  };
  return (
    <React.Fragment>
      &nbsp;
      <div className="message">
        {textInformation[model.paymentResult.paymentMethod] ?? (
          <p>
            <Translate
              hasHTML
              term="Este é um produto digital, estamos preparando com carinho a entrega do seu conteúdo no seu <b>e-mail</b>. Enquanto isso, confirme os seus dados."
            />
          </p>
        )}
      </div>
      <div className="data">
        <div className="user">
          <p>
            <SvgIcon name="user" />
            <span>{model.studdent ? model.studdent.name : model.user.name}</span>
          </p>
          <p>
            <SvgIcon name="email" />
            <span>{model.studdent ? model.studdent.email : model.user.email}</span>
          </p>
        </div>
      </div>
      <div className={'alert'}>
        <SupportContactText contactEmail={model.content.producerEmail} />
      </div>
    </React.Fragment>
  );
};

export default React.memo(Info);
